var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-input-number',{attrs:{"min":_vm.min,"step":_vm.step},on:{"input":_vm.setVal},model:{value:(_vm.ActionScore),callback:function ($$v) {_vm.ActionScore=$$v},expression:"ActionScore"}})
}
var staticRenderFns = []

export { render, staticRenderFns }